import { get, isMockMode, simulateDelay } from "../api";

export const getServiceSubById = ({ subscriptionId }) => {
	if (isMockMode()) {
		const testData = {
			sub: {
				id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				name: "Test Name",
				subscriberOrgId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				isDeleted: false,
				isEnabled: true,
				expirationDateUtc: "2050-12-30T13:00:00",
			},
			licences: [],
			usedLicences: 0,
			totalLicences: 1000,
		};

		return simulateDelay(50, () => testData);
	}

	return get(
		`Subscriptions/GetServiceSubById?subscriptionId=${subscriptionId}`
	);
};
